const pendingApprovalForStrategyAnalyst = ({ initiatives }) => {
  if (!initiatives || !Array.isArray(initiatives)) {
    console.warn('pendingApprovalForStrategyAnalyst: initiatives is not a valid array', initiatives);
    return { pendingAnalyst: [], approvedAnalyst: [], notSetAnalyst: [] };
  }
  const pendingAnalyst = [];
  const approvedAnalyst = [];
  const notSetAnalyst = [];

  // Define mappings for requested stages to their corresponding approval keys.
  const approvalStageMap = {
    'Submitted for L1 Approval': 'L1',
    'Submitted for L2 Approval': 'L2',
    'Submitted for L3 Approval': 'L3',
    'Submitted for L4 Approval': 'L4',
    'Submitted for L5 Approval': 'L5',
  };

  // Helper function to check if the requested stage is valid for the current stage.
  const isStageValidForApproval = (currentStage, requestedApprovalKey) => {
    if (!requestedApprovalKey) return false;

    const currentStageNum = parseInt(currentStage.replace('L', ''), 10);
    const requestedApprovalNum = parseInt(requestedApprovalKey.replace('L', ''), 10);

    return requestedApprovalNum === currentStageNum || requestedApprovalNum === currentStageNum + 1;
  };

  initiatives.forEach((initiative) => {
    let categorized = false;

    if (!initiative.request || !initiative.request.requestedStage) {
      notSetAnalyst.push(initiative);
      categorized = true;
      return;
    }

    const stage = initiative.stage;
    const requestedStage = initiative.request.requestedStage;
    let approvalStageKey = null;
    let expectedApproverCountForPending = 0;
    let expectedApproverCountForApproved = 0;

    // ========== CASES FOR hasFinancialImpact === false ==========
    if (initiative.hasFinancialImpact === false) {
      // Case 1: L0 stage with Submitted for L1 Approval
      if (stage === 'L0' && requestedStage === 'Submitted for L1 Approval') {
        approvalStageKey = approvalStageMap[requestedStage];
        expectedApproverCountForPending = 1;
        expectedApproverCountForApproved = 2;
      }
      // Case 2: L1 stage with Submitted for L2 Approval
      else if (stage === 'L1' && requestedStage === 'Submitted for L2 Approval') {
        approvalStageKey = approvalStageMap[requestedStage];
        expectedApproverCountForPending = 2;
        expectedApproverCountForApproved = 3;
      }
      // Case 3: L2 stage with Submitted for L3 Approval
      else if (stage === 'L2' && requestedStage === 'Submitted for L3 Approval') {
        approvalStageKey = approvalStageMap[requestedStage];
        expectedApproverCountForPending = 2;
        expectedApproverCountForApproved = 3;
      }
      // Case 4: L3 stage with Submitted for L4 Approval
      else if (stage === 'L3' && requestedStage === 'Submitted for L4 Approval') {
        approvalStageKey = approvalStageMap[requestedStage];
        expectedApproverCountForPending = 2;
        expectedApproverCountForApproved = 3;
      }
      // Case 5: L4 stage with Submitted for L5 Approval
      else if (stage === 'L4' && requestedStage === 'Submitted for L5 Approval') {
        approvalStageKey = approvalStageMap[requestedStage];
        expectedApproverCountForPending = 2;
        expectedApproverCountForApproved = 3;
      }
    }
    // ========== CASES FOR hasFinancialImpact === true ==========
    else if (initiative.hasFinancialImpact === true) {
      // ONLY L0 stage with Submitted for L1 Approval should go to Strategy Analyst
      if (stage === 'L0' && requestedStage === 'Submitted for L1 Approval') {
        approvalStageKey = approvalStageMap[requestedStage];
        expectedApproverCountForPending = 1;
        expectedApproverCountForApproved = 3;
      }
      // All other cases with hasFinancialImpact === true are NOT for Strategy Analyst
    }

    // Process if a valid approvalStageKey was determined
    if (approvalStageKey && isStageValidForApproval(stage, approvalStageKey)) {
      if (initiative.approvalSummary && initiative.approvalSummary[approvalStageKey]) {
        const approvers = initiative.approvalSummary[approvalStageKey].approvers || [];

        if (approvers.length === expectedApproverCountForPending) {
          pendingAnalyst.push(initiative);
          categorized = true;
        } else if (approvers.length === expectedApproverCountForApproved) {
          approvedAnalyst.push(initiative);
          categorized = true;
        }
      }
    }

    if (!categorized) {
      notSetAnalyst.push(initiative);
    }
  });

  return { pendingAnalyst, approvedAnalyst, notSetAnalyst };
};

export default pendingApprovalForStrategyAnalyst;